<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Stock Reservado</h4>
            <div class="small text-muted">Stock reservado por productos</div>
          </b-col>
          
          <b-col sm="5">
            <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Producto">
              <i class="fa fa-plus"></i> Agregar
            </b-button>
          </b-col>                    
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">  
        <b-row>
          <b-col md="12" v-if="ordersReason" class="mb-2">
            <h3>
              <b>{{this.ordersReason.id}} - {{this.ordersReason.name}}</b>
              <br>
              <small>
                <u><b>Reservado</b></u> (Por Default): Casilda <b-badge variant="secondary">{{ this.ordersReason.stock_reserved }} U</b-badge>
                · BsAs <b-badge variant="secondary">{{ this.ordersReason.stock_reserved_bsas }} U</b-badge>
              </small>
            </h3>
          </b-col>

          <b-col>
            <b-table class="mb-0"
                    ref="table"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"                    
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :busy="table.isBusy"     
                    v-if="(table.items && table.items.length) || table.isBusy">                       
                
                <template v-slot:cell(id)="data">
                  <b>#{{data.item.id}}</b>
                </template>

                <template v-slot:cell(code)="data">
                  {{data.item.product_color.code}}
                </template>                

                <template v-slot:cell(name)="data">
                  {{data.item.product_color.name}}
                </template>                

                <template v-slot:cell(color)="data">
                  <div v-if="data.item.product_color.color">
                    {{data.item.product_color.color.name}}
                  </div>
                </template>                                

                <template v-slot:cell(stock_reserved)="data">
                  <div><small>Casilda:</small> <b-badge variant="secondary" style="font-size: 13px;">{{data.item.stock_reserved}} U</b-badge></div>
                  <div class="mt-1"><small>BsAs:</small> <b-badge variant="secondary" style="font-size: 13px;">{{data.item.stock_reserved_bsas}} U</b-badge></div>
                </template>     

                <template v-slot:cell(date_expiration)="data">
                  <span v-if="data.item.date_expiration" :class="{'text-danger': moment(data.item.date_expiration).isBefore(moment())}">
                    {{moment(data.item.date_expiration).format('DD/MM/YYYY')}}
                  </span>                  
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">                    
                    <b-dropdown-item @click="edit(data.item)">
                      <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>

          <b-col>            
            <nav v-if="table.tablePaginate">
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="table.tablePaginate.total"
                            :per-page="table.tablePaginate.per_page"
                            v-model="table.currentPage" 
                            @input="filter()" />
            </nav>             
          </b-col>          
        </b-row>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white">
        <div slot="modal-header">
          {{this.modal.form.title}}
        </div>

        <b-row>      
          <b-col md="12" class="mt-3 mb-2">
            <FindObject render="search"
                          type="productsColorsVariant" 
                          @select-object="loadProductsColorsVariant($event)" 
                          :valueID="crud.form.products_colors_id"
                          :key="crud.form.products_colors_id"/>
          </b-col>
          <b-col md="6" class="mt-3 mb-2">
            <b-form-group label="Stock Reservado Casilda">
              <b-form-input type="number"
                            size="sm"
                            v-model="crud.form.stock_reserved"
                            required
                            placeholder="Ingresar un valor numérico">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6" class="mt-3 mb-2">
            <b-form-group label="Stock Reservado BsAs">
              <b-form-input type="number"
                            size="sm"
                            v-model="crud.form.stock_reserved_bsas"
                            required
                            placeholder="Ingresar un valor numérico">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-3 mb-2">
            <b-form-group label="Fecha Vigencia" description="Fecha de expiración para el stock reservado">
              <b-form-datepicker 
                size="sm" 
                v-model="crud.form.date_expiration" 
                placeholder="Fecha Vigencia" 
                local="es"
                reset-button>
              </b-form-datepicker>                      
            </b-form-group>            
          </b-col>          
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>          
        </div>
      </b-modal>    
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import Param from '@/config/parameters'
  import FindObject from '@/components/inc/find/findObject'  

  export default {
    components: {
      FindObject,      
    },        
    data: () => {
      return {      
        access: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudOrdersReasonStockReserved',
          elements: {}
        },         
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', class: 'text-centeralign-middle'},  
            {key: 'code', label: 'Codigo', class: 'text-left align-middle'},     
            {key: 'name', label: 'Nombre', class: 'text-left align-middle'},     
            {key: 'color', label: 'Color', class: 'text-center align-middle'},     
            {key: 'stock_reserved', label: 'Reservado', class: 'text-center align-middle'},     
            {key: 'date_expiration', label: 'Vigencia', class: 'text-center align-middle'},                 
            {key: 'f_action', label:'', class: 'text-right align-middle'},
          ],          
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,                
        },
        crud: {
          form: {
            id: 0,         
            orders_reason_id: 0,
            products_colors: null,   
            products_colors_id: 0,
            stock_reserved: 0,
            stock_reserved_bsas: 0,
            date_expiration: null,
          },          
        },
        modal: {
          form: {
            active: false,
            title: ''
          },       
        },       
        filters: {
          orders_reason_id: 0,
        },
        ordersReasonID : 0, 
        ordersReason: null,        
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.ordersReasonID = this.$route.params.reasonID  
      
      this.loadOrdersReason()
      this.filter()      
    },
    methods: {
      // select 
      loadOrdersReason() {        
        var result = serviceAPI.mostrarMotivos(this.ordersReasonID)

        result.then((response) => {
          var data = response.data
          this.ordersReason = data
        })         
      },
      loadProductsColorsVariant (object) {
        if(object){
          this.crud.form.products_colors = object
          this.crud.form.products_colors_id = object.id             
        } else {
          this.crud.form.products_colors = null
          this.crud.form.products_colors_id = 0
        }
      }, 
            
      // crud
      filter() {
        this.table.isBusy = true

        this.filters.orders_reason_id = this.ordersReasonID        
        var result = serviceAPI.filtrarStockRerserved(this.filters, this.table.currentPage)

        result.then((response) => {
          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data

          if(this.$refs.table) {                        
            this.$refs.table.$forceUpdate()
          }  

          this.table.isBusy = false          
        })
        .catch(error => {
          this.table.isBusy = false
          //this.$awn.alert(Error.showError(error))
        });        
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.orders_reason_id = this.ordersReasonID
        this.crud.form.products_colors_id = 0 
        this.crud.form.stock_reserved = 0
        this.crud.form.stock_reserved_bsas = 0
        this.crud.form.date_expiration = null

        this.modal.form.title = "Nuevo Producto con Stock Reservado"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        
        this.crud.form.orders_reason_id = item.orders_reason_id
        this.crud.form.products_colors_id = item.products_colors_id            
        this.crud.form.stock_reserved = item.stock_reserved
        this.crud.form.stock_reserved_bsas = item.stock_reserved_bsas
        this.crud.form.date_expiration = item.date_expiration

        this.modal.form.title = "Editar Producto con Stock Reservado"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.$bvModal.msgBoxConfirm('¿Desea borrar el producto (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Motivo',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarStockRerserved(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.filter()
              this.$awn.success("Producto con Stock Reservado Eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();

        if(this.crud.form.date_expiration == '0000-00-00' || this.crud.form.date_expiration == '') {
          this.crud.form.date_expiration = null
        }

        var result = null
        if (this.crud.form.id) {
          result = serviceAPI.editarStockRerserved(this.crud.form);
        } else {
          result = serviceAPI.agregarStockRerserved(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.filter()
          this.$awn.success("Cambios guardado con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },                       
    }    
  }
</script>
<style>

</style>